import { http } from './client';
import { API_ROUTES } from './routes';
import type { ICompany, ICreateCompanyPayload, IUpdateCompanyPayload } from '@/types/company';

export const companyApi = {
  list: (): Promise<ICompany[]> =>
    http.get(API_ROUTES.company.list).then((r) => r.data),

  create: (payload: ICreateCompanyPayload): Promise<ICompany> =>
    http.post(API_ROUTES.company.create, payload).then((r) => r.data),

  update: (id: string, payload: IUpdateCompanyPayload): Promise<ICompany> =>
    http.patch(API_ROUTES.company.update(id), payload).then((r) => r.data),
};
